import React, { useState, createRef } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { STIcon } from 'components/Brand/Icons/STIcon';

import '../Video.less';

const VideoButton = ({ children, title, mainSrc, color, type, ...otherProps }) => {
  const [isPlaying, setPlaying] = useState(false);
  const mainVideo = createRef();
  const videoContainerX = 0; // - parseFloat(ratioWidth / ratioHeight) * parseFloat(height) / 2;

  const onPlayButtonClick = e => {
    setPlaying(true);

    mainVideo.current.play();
  };

  const onBackDropClick = e => {
    setPlaying(false);

    mainVideo.current.pause();
  };

  const onMainVideoEnded = e => {
    setPlaying(false);
  };

  return (
    <div {...otherProps}>
      <button
        className={type === 'normal' ? 'Video__playButton' : 'Video__playButton_old'}
        onClick={onPlayButtonClick}
        aria-label="Play/Pause Button"
      >
        <span className={'Helm-Icon' + ' color-' + color}>
          <STIcon type="icon-play" />
          {type === 'normal' ? title : ''}
        </span>
      </button>

      <MainDiv className={'VideoMainDiv' + (isPlaying ? ' VideoMainDiv--playing' : '')}>
        <div
          className={'Backdrop' + (isPlaying ? ' Backdrop--visible' : '')}
          onClick={onBackDropClick}
        ></div>
        <div className={'TransformingVideo' + (isPlaying ? ' TransformingVideo--playing' : '')}>
          <div className="TransformingVideo__widthConstraint">
            <div
              className={
                'TransformingVideo__container' +
                (isPlaying ? ' TransformingVideo__container--playing' : '')
              }
              style={{ transform: `translateX(${videoContainerX}px)` }}
            >
              <div
                className={
                  'TransformingVideo__actualVideo' +
                  (isPlaying ? ' TransformingVideo__actualVideo--playing' : '')
                }
              >
                <video
                  ref={mainVideo}
                  controls={isPlaying ? 'controls' : ''}
                  style={{ width: 'auto' }}
                  onEnded={onMainVideoEnded}
                >
                  <source src={mainSrc} type="video/mp4" />
                </video>
              </div>
            </div>
          </div>
        </div>
      </MainDiv>
    </div>
  );
};

VideoButton.propTypes = {
  mainSrc: PropTypes.string,
  color: PropTypes.string,
};

VideoButton.defaultProps = {
  color: 'blue', // blue, white
  type: 'normal', // 'old'
};

const MainDiv = styled.div`
  position: relative;
  box-sizing: content-box;
`;

export default VideoButton;
